export default __webpack_public_path__ + "static/media/google_doc.8f66dadd.png";